import { useAuth } from '../auth/useAuth';
import { DashboardAdministratifPage } from './DashboardAdministratifPage';
import { DashboardCommercialPage } from './DashboardCommercialPage';
import { DashboardApprenantPage } from './DashboardApprenantPage';
import { DashboardFormateurPage } from './DashboardFormateurPage';
import { DashboardPedagogiquePage } from './DashboardPedagogiquePage';
import { DashboardFacturationPage } from './DashboardFacturationPage';
import { DashboardDirectionPage } from './DashboardDirectionPage';

/**
 * Tableau de bord principal aiguillé par profil :
 * Restitue fidèlement les maquettes validées par profil (Apprenant, Formateur,
 * Responsable/Assistant pédagogique, Facturation, Direction, Administratif,
 * Recrutement et Relation entreprise).
 */
export function DashboardPage(): JSX.Element {
  const { utilisateur } = useAuth();
  if (!utilisateur) return <div />;

  switch (utilisateur.profil) {
    case 'ADMINISTRATIF':
      return <DashboardAdministratifPage />;

    case 'RECRUTEMENT':
    case 'RELATION_ENTREPRISE':
      return <DashboardCommercialPage />;

    case 'APPRENANT':
      return <DashboardApprenantPage />;

    case 'FORMATEUR':
      return <DashboardFormateurPage />;

    case 'PEDAGOGIQUE':
      return <DashboardPedagogiquePage />;

    case 'FACTURATION':
      return <DashboardFacturationPage />;

    case 'DIRECTION':
      return <DashboardDirectionPage />;

    default:
      return <DashboardApprenantPage />;
  }
}
